import { IconType, GenIcon } from "react-icons/lib/esm/iconBase";

export const PauseIcon: IconType = GenIcon({
  tag: "svg",
  attr: { viewBox: "0 0 512 512" },
  child: [
    {
      tag: "path",
      attr: {
        d: "M96 448h106.7V64H96v384zM309.3 64v384H416V64H309.3z",
      },
      child: [],
    },
  ],
});
